import BookmakerAssetModel from "./BookmakerAssetModel";
import BookmakerBrandingModel from "./BookmakerBrandingModel";
import BookmakerLinkModel from "./BookmakerLinkModel";
import BookmakerUrlModel from "./BookmakerUrlModel";

export default class BookmakerModel {
  public id: string = null;
  public name: string = null;
  public url: string = null;
  public assets: BookmakerAssetModel[] = [];
  public links: BookmakerLinkModel[] = [];
  public branding: BookmakerBrandingModel | null = null;
  public eventUrls: BookmakerUrlModel[] = [];
  public stakesDisclaimer: string = null;
  public domainName: string = null;
}
